<template>
  <vs-popup
    class="rm-batch-taste-panel-popup"
    :title="`SUMMARY - ${batchCode}`"
    :active.sync="open"
    :buttons-hidden="true"
    @close="closePopup"
  >
    <vx-card no-shadow>
      <div v-if="panelDetails && Object.keys(panelDetails).length">

        <div class="grid grid-cols-2 gap-y-6 gap-x-8">
          <div>
            <div class="text-sm font-semibold mb-1">Code</div>
            <div class="text-sm">
              <HyperLink :id="panelDetails.id" type="tasting-group">{{ panelDetails.code ? panelDetails.code : "-" }}</HyperLink>
            </div>
          </div>

          <div>
            <div class="text-sm font-semibold mb-1">Status</div>
            <div class="text-sm">
              {{ signOffDetails.status ? signOffDetails.status : "Pending" }}
            </div>
          </div>

          <div>
            <div class="text-sm font-semibold mb-1">Created By</div>
            <div class="text-sm">
              {{
                panelDetails.created_by
                  ? panelDetails.created_by
                  : "-"
              }}
            </div>
          </div>

          <div>
            <div class="text-sm font-semibold mb-1">Sign Off By</div>
            <div class="text-sm">
              {{
                signOffDetails.signed_by && signOffDetails.signed_by.name
                  ? signOffDetails.signed_by.name
                  : "-"
              }}
            </div>
          </div>
        </div>

        <div class="mt-8">
          <div class="text-sm font-semibold mb-2">Note</div>
          <div class="text-sm">
            {{ signOffDetails.comment ? signOffDetails.comment : "No notes available" }}
          </div>
        </div>

        <!-- <div class="flex justify-end mt-10">
          <vs-button type="border" @click="closePopup"> Close </vs-button>
        </div> -->
      </div>

      <div v-else class="text-center py-10">
        <span>No details available.</span>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
export default {
  name: "RmBatchTastePanelSummery",

  data() {
    return {
      open: false,
      panelDetails: {},
      signOffDetails: {},
      batchCode: "",
    };
  },

  methods: {
    openPopUp(batchCode , panel, signOffDetails) {
      this.batchCode = batchCode;
      this.panelDetails = panel ? panel : {};
      this.signOffDetails = signOffDetails ? signOffDetails : {};
      this.open = true;
    },

    closePopup() {
      this.open = false;
      this.panelDetails = {};
      this.signOffDetails = {};
      this.batchCode = "";
    },

    onClickOpenTastePanel(id) {
      const route = this.$router.resolve({
        path: "/pages/taste-panels",
        query: { open: id },
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>
